export default __webpack_public_path__ + "static/media/shutterstock_638351104.9dc1612e.png";